<template>
  <!-- can-cancel = ['escape', 'x', 'outside'] si se quiere que cierre  por cualqiera de esos [] caso contrario -->
  <b-modal :active.sync="isModalActive" :width="680" scroll="keep" :can-cancel="[]">
    <b-loading :is-full-page="false" v-model="isLoading" :can-cancel="false"></b-loading>
    <div class="rounded-lg bg-white overflow-hidden border border-[#E4E6EB] shadow-lg">
      <!-- HEADER estilo Meta -->
      <header class="flex justify-between items-center px-4 py-3 border-b border-[#E4E6EB] bg-white">
        <div class="flex-1 min-w-0">
          <h2 class="text-base font-semibold text-gray-900 break-words whitespace-normal">
            {{ $t('configure_subdivisions_title') }}
          </h2>
        </div>
        <button
          v-if="!processingData"
          @click="hide()"
          class="flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-full text-gray-500 hover:bg-gray-100 transition-colors duration-150 focus:outline-none focus:ring-2 focus:ring-gray-300 focus:ring-offset-1"
          aria-label="Cerrar"
        >
          <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path>
          </svg>
        </button>
      </header>

      <!-- CONTENIDO -->
      <div class="px-4 py-4 space-y-4 bg-white">

        <!-- Resumen: total de estructuras detectadas (POLYLINE/LWPOLYLINE) -->
        <div class="flex items-center justify-between bg-blue-50 border border-blue-200 rounded-lg px-3 py-2">
          <span class="text-sm font-medium text-blue-800">
            <b-icon pack="fas" icon="stream" size="is-small" class="mr-1"></b-icon>
            {{ $t('total_structures') }}
          </span>
          <span class="text-base font-bold text-blue-900">{{ totalStructures }}</span>
        </div>

        <!-- Switches globales: tipos de subdivisión a generar (en una sola fila, con wrap si no caben) -->
        <div class="flex flex-row flex-wrap items-center gap-x-6 gap-y-2">
          <b-field class="mb-0">
            <b-switch v-model="createElements.pilings"
              :rounded="true"
              :outlined="false"
              size="is-small"
              type="is-success"
              :left-label="true">
              {{ $t('create') }} {{ $t('pilings') }}
            </b-switch>
          </b-field>

          <b-field class="mb-0">
            <b-switch v-model="createElements.modules"
              :rounded="true"
              :outlined="false"
              size="is-small"
              type="is-success"
              :left-label="true">
              {{ $t('create') }} {{ $t('modules') }}
            </b-switch>
          </b-field>

          <b-field class="mb-0">
            <b-switch v-model="layeredDesign"
              :rounded="true"
              :outlined="false"
              size="is-small"
              type="is-info"
              :left-label="true">
              {{ $t('subdivide_by_layer') }}
            </b-switch>
          </b-field>
        </div>

        <!-- Tabs: General siempre visible. "Por capas" solo si layeredDesign está activo. -->
        <b-tabs v-model="activeTab" type="is-boxed" size="is-small" :animated="false">
          <b-tab-item :label="$t('general')" icon="cog" icon-pack="fas">
            <fields-design-form ref="frm_default"
              :disable-fields="processingData"
              :create-elements="createElements" />
          </b-tab-item>

          <b-tab-item v-if="layeredDesign" :label="$t('by_layer')" icon="layer-group" icon-pack="fas">
            <layers-design-list ref="refLayersDesign"
              :layers="layers"
              :create-elements="createElements"
              :disable-fields="processingData" />
          </b-tab-item>
        </b-tabs>

      </div>

      <!-- FOOTER estilo Meta -->
      <footer class="px-4 py-3 border-t border-[#E4E6EB] bg-white">
        <div class="w-full flex items-center gap-2" :class="processingData ? 'justify-center' : 'justify-between'">
          <v-button v-if="!processingData" color="grey" icon="door-closed" size="is-small" @click="hide()">{{ $t('close') }}</v-button>
          <v-button v-if="!processingData" @click="handleClick()" icon="check" size="is-small">
            {{ $t('accept') }}
          </v-button>
          <v-button-processing v-if="processingData" />
        </div>
      </footer>
    </div>
  </b-modal>
</template>

<script>
import FieldsDesignForm from "../../../components/fields-design-form.vue"
import LayersDesignList from "../../../components/layers-design-list.vue"

export default {
  name: "ConfigureSubdivisionsModal",

  components: {
    FieldsDesignForm,
    LayersDesignList,
  },

  props: {

  },

  data() {
    return {
      isModalActive: false,
      isLoading: false,
      processingData: false,

      // Pestaña activa: 0 = General, 1 = Por capas
      activeTab: 0,
      // Si el switch está activo, se muestra el tab "Por capas" y se procesan los overrides
      layeredDesign: false,
      // Capas del DXF (extraídas de cadJson.tables.layer.layers en show())
      layers: [],
      // Total de estructuras detectadas en el DXF (POLYLINE/LWPOLYLINE)
      totalStructures: 0,
      // Qué tipos de entidad debe generar el procesador
      createElements: {
        pilings: false,
        modules: false,
      },
    }
  },

  watch: {
    // Si el usuario apaga el switch estando en el tab "Por capas", regresa al General.
    layeredDesign(active) {
      if (!active && this.activeTab !== 0) this.activeTab = 0
    },
  },

  methods: {
    /**
     * Valida los formularios y emite la configuración al padre.
     * No procesa nada por sí mismo — solo recolecta y entrega.
     * El form "Por capas" solo se consulta si el switch layeredDesign está activo.
     */
    handleClick() {
      const defaultDesign = this.$refs.frm_default.getDataForm()
      // Si la validación falló, el form ya disparó el $toast.
      if (defaultDesign == null) return

      const cadLayersDesign = (this.layeredDesign && this.$refs.refLayersDesign)
        ? this.$refs.refLayersDesign.getDataDesign()
        : {}

      const cadLayeredDesign = Object.assign({}, { default: defaultDesign }, cadLayersDesign)

      this.$emit('epc-apply', {
        cadLayeredDesign,
        createElements: this.createElements,
      })

      this.hide()
    },

    /**
     * Abre el modal. Recibe el cadJson completo y extrae lo que necesita:
     *   - layers para <layers-design-list>
     *   - totalStructures (count de POLYLINE/LWPOLYLINE) para mostrar en el resumen
     * @param {Object} cadJson - resultado del parser DXF
     */
    show(cadJson) {
      this.layers = Object.values(cadJson?.tables?.layer?.layers || {})
      this.totalStructures = (cadJson?.entities || []).filter(
        e => e.type === 'POLYLINE' || e.type === 'LWPOLYLINE'
      ).length
      this.activeTab = 0
      this.layeredDesign = false
      this.isModalActive = true
    },

    hide() {
      this.isModalActive = false
    },
  },
};
</script>

<style scoped>
  /* Oculta los botones para aumentar los inputs numéricos */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    /* display: none; <- Crashes Chrome on hover */
    -webkit-appearance: none;
    margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
  }

  input[type="number"] {
    -moz-appearance: textfield; /* Firefox */
    appearance: textfield; /* Estándar */
  }

  /* Scrollbar personalizado estilo Material Design 3 */
  .custom-scrollbar::-webkit-scrollbar {
    width: 6px;
  }

  .custom-scrollbar::-webkit-scrollbar-track {
    background: #f1f5f9;
    border-radius: 3px;
  }

  .custom-scrollbar::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 3px;
  }

  .custom-scrollbar::-webkit-scrollbar-thumb:hover {
    background: #94a3b8;
  }
</style>
